export default class ISiteActionEventData {
    constructor(launchId, category, action, value) {
        this.category = category;
        this.action = action;
        this.value = value;
        this.launchId = launchId;
    }
}
